import { EntryCollection, Asset, Entry } from 'contentful';
import { RichTextContent } from 'types/RichTextContent';
import { getEntries, getEntry } from './ContentfulClient';

type ContentfulComicPost = {
  title: string;
  slug: string;
  image: Asset;
  thumbnail: Asset;
  blurb: string;
  publishDate: string;
  screenReader: RichTextContent;
  breakers: object[];
  previousChapter?: Entry<ContentfulComicPost>;
  nextChapter?: Entry<ContentfulComicPost>;
};

const transformComicPost = (comicPost: Entry<ContentfulComicPost>) => {
  const { sys, fields } = comicPost;
  const {
    title,
    slug,
    image,
    thumbnail,
    blurb,
    publishDate,
    screenReader,
    breakers,
    previousChapter,
    nextChapter,
  } = fields;

  return {
    title,
    slug,
    blurb,
    screenReader,
    id: sys.id,
    imageUrl: image?.fields?.file?.url || '',
    thumbnailUrl: thumbnail?.fields?.file?.url || '',
    publishDate: new Date(publishDate),
    breakers,
    previousChapter: previousChapter ? transformComicPostLink(previousChapter) : undefined,
    nextChapter: nextChapter ? transformComicPostLink(nextChapter) : undefined,
  };
};

const transformComicPostLink = (comic: Entry<ContentfulComicPost>) => {
  const { id } = comic.sys;
  const { slug } = comic.fields;

  return {
    id,
    slug,
  };
};

const transformAllComicPosts = (comic: EntryCollection<ContentfulComicPost>) => {
  return comic.items.map(transformComicPost);
};

export const getAllComicPosts = async () => {
  return transformAllComicPosts(await getEntries<ContentfulComicPost>('webcomic'));
};

export const getComicPost = async (id: string) => {
  return transformComicPost(await getEntry<ContentfulComicPost>(id));
};
